import * as Yup from "yup";

const WaiverRegistrationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const WaiverRegistration = Yup.object().shape({
    fullname: Yup.string().required('Fullname is required'),
    birthDate: Yup.string().required('BirthDate is required'),
    phone: Yup.string().required('Phone is required'),
    // country: Yup.object().required('Country is required'),
    // address: Yup.string().required("Address is required"),
    // city: Yup.object().required('City is required'),
});

const UserRegistrationSchema = Yup.object().shape({
    email: Yup.string().required('email is required'),
    password: Yup.string().required('password is required'),
    brand: Yup.string().required('Brand is required'),
});

export { UserRegistrationSchema, WaiverRegistration, WaiverRegistrationSchema };

